import React from 'react'
import dayjs, { Dayjs } from 'dayjs'
import parseJsonSafe from './parseJsonSafe'
import DateFormat from '../../store/types/enums/DateFormat'
import { User } from '../../store/types'
import ModificationHistoryBase from '../ModificationHistory/ModificationHistoryBase'
import FilteredHistoryRows from './FilteredHistoryRows'
import { t } from 'i18next'
import { History } from '../../store/redux/reducers/auditSlice'

interface ModificationHistoryProps {
  selectedDate: Dayjs
  onLeaveButtonClick: () => void
  historyType: string
  selected: User | null
}

const ModificationHistoryComponent: React.FC<ModificationHistoryProps> = ({
  selectedDate,
  onLeaveButtonClick,
  historyType,
  selected,
}) => {
  const filterFn = (item: History, selectedDate: Dayjs) => {
    const oldDates = parseJsonSafe(item.oldValue)
    const newDates = parseJsonSafe(item.newValue)
    const status = Object.keys(oldDates).length ? oldDates.status : newDates.status
    const compareDate = dayjs(oldDates.start_time || newDates.start_time).format(DateFormat.MonthYear)
    const selectedMonthYear = selectedDate.format(DateFormat.MonthYear)
    return status === historyType && compareDate === selectedMonthYear
  }

  const renderRows = (date: string, filteredAuditData: History[], selectedDate: Dayjs) => (
    <FilteredHistoryRows filteredAuditData={filteredAuditData} date={date} selectedDate={selectedDate} />
  )

  return (
    <ModificationHistoryBase
      selectedDate={selectedDate}
      selected={selected}
      tableName="work_activity"
      title={t('page.schedule.modificationHistory.title')}
      onLeaveButtonClick={onLeaveButtonClick}
      filterFn={filterFn}
      renderRows={renderRows}
    />
  )
}

export default ModificationHistoryComponent